import { Box, Grid } from "@mui/material";
import { memo } from "react";

import NavigatorCard from "../../components/UI/HomeNavigation/NavigatorCard";
import { INavigationItem } from "../../models/navigation";

const ITEMS: INavigationItem[] = [
  {
    name: "page.triageEmergencyDepartment.new_triage",
    link: "newTriage",
    icon: (
      <img
        style={{ height: 75 }}
        src="/actions/default/schedule-add.png"
        alt={"NewTriage"}
      />
    ),
    isExtensionInstalled: true,
  },
  {
    name: "page.triageEmergencyDepartment.my_triages",
    link: "myTriages",
    icon: (
      <img
        style={{ height: 75 }}
        src="/actions/default/schedule-history.png"
        alt={"MyTriage"}
      />
    ),
    isExtensionInstalled: true,
  },
  {
    name: "page.triageEmergencyDepartment.familyGroup",
    link: "familyGroup",
    icon: (
      <img
        style={{ height: 75 }}
        src="/actions/default/schedule-group.png"
        alt={"FamilyGroup"}
      />
    ),
    isExtensionInstalled: true,
  },
  {
    name: "page.triageEmergencyDepartment.insurance",
    link: "insurance",
    icon: (
      <img
        style={{ height: 75 }}
        src="/actions/default/schedule-insurance.png"
        alt={"Insurance"}
      />
    ),
    isExtensionInstalled: true,
  },
];

const Actions = () => {
  return (
    <Box>
      <Grid
        flexDirection={"row"}
        container
        sx={({ breakpoints }) => ({
          [breakpoints.down("md")]: {
            flexWrap: "nowrap",
            gap: 2,
          },

          [breakpoints.up("md")]: {
            flexWrap: "wrap",
            gap: 3,
          },
          overflowX: "auto",
        })}
      >
        {ITEMS.map((item) => (
          <Grid item xs={"auto"} key={item.link}>
            <NavigatorCard {...item} />
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default memo(Actions);
